var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.474,
    height: 36,
    viewBox: "0 0 36.474 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_126",
    transform: "translate(-3643.5 -4846)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_125"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    transform: "translate(3656 4859)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_72",
    width: 4,
    height: 8,
    rx: 2,
    transform: "translate(3660 4874)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_259",
    width: 4,
    height: 9,
    rx: 2,
    transform: "translate(3660 4846)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_260",
    width: 3.965,
    height: 8.722,
    rx: 1.982,
    transform: "translate(3671.252 4866.219) rotate(-90)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_261",
    width: 3.965,
    height: 8.722,
    rx: 1.982,
    transform: "translate(3643.5 4866.219) rotate(-90)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_262",
    width: 3.965,
    height: 8.722,
    rx: 1.982,
    transform: "translate(3653.607 4869.563) rotate(45)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_263",
    width: 3.965,
    height: 8.722,
    rx: 1.982,
    transform: "translate(3673.23 4849.94) rotate(45)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_264",
    width: 3.965,
    height: 8.722,
    rx: 1.982,
    transform: "translate(3667.063 4872.366) rotate(-45)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_265",
    width: 3.965,
    height: 8.722,
    rx: 1.982,
    transform: "translate(3647.44 4852.743) rotate(-45)",
    fill: "current"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.ed1237bf3db958220961e4de8a4f5477.svg";
export { ForwardRef as ReactComponent };